import _ from 'lodash'
import '../lib/Leaflet-WFST'
import './WFSTFilterIn'
import './WFSTFilterLike'

class OOPT {
    constructor(vue) {
        this.vm = vue;
    }

    territorySearch(query) {
        return this.vm.$http
            .get('/map/search/territory-search', {params: {q: query}})
            .then(response => response.body)
    }

    intersectsSearch(query, layers) {
        if (!query) {
            return Promise.resolve([]);
        }

        let _getFilter = () => {
            if (_.isString(query)) {
                return new L.Filter.Like().append('Name', `*${query}*`);
            }

            if (_.hasIn(query, 'toGml')) {
                return new L.Filter.Intersects().append(query, 'Shape', crs);
            }

            if (_.hasIn(query, 'param')) {
                return new L.Filter.IN().append(query.param, query.ids);
            }
        };

        let url = this.vm.getWfsService();
        let crs = L.CRS.EPSG4326;

        let filter = _getFilter();

        let promises = layers.map(layer => new Promise(function (resolve, reject) {
            let type = layer.split(':');

            let wfs = new L.WFS({
                url: url,
                typeNS: type[0],
                typeName: type[1],
                crs: crs,
                filter: filter,
                emptyGroups: true
            }).once('load', () => resolve(wfs.getLayers()));
            // }).once('load', () => resolve(wfs.getLayers().map(layer => layer.toGeoJSON())));

            wfs.on('error', () => reject(`Не удалось выполнить поиск. Возможно, сервер ГИС недоступен или не может обработать
 запрос из-за ошибок в геометрии или внутренней проблемы. Объекты на карте или в поисковом запросе не должны выходить за
 пределы географической сетки, содержать самопересечений или полигоны из менее, чем трех точек`));
        }));

        return Promise.all(promises).then(_.flatten);
    }

    isValidResult(feature) {
        // @TODO: Что такое валидный для геопоиска результат? ООПТ - Действующие границы ООПТ
        return true; // _.get(feature, 'properties.StatusId') == 2;
    }

    defaultLayers() {
        // return ["GTS:hydrotechnical_shape_view"/*, "GTS:hydrotechnical_shape"*/];
        return ["OOPT:NatureClusterShapeView"];
    }

    intersectsSearchLayer(query, layer) {
        return this.intersectsSearch(query, [layer]);
    }

    intersectsSearchValid(query) {
        return this.intersectsSearch(query, this.defaultLayers()).then(features => _.filter(features, this.isValidResult));
    }

    intersectsSearchAll(query) {
        return this.intersectsSearch(query, this.defaultLayers());
    }

    coordinateSearch(latlng, options) {
        let map = this.vm.map;
        let crs = L.CRS.EPSG4326;
        let bounds = map.getBounds();
        let size = map.getSize();
        let nw = crs.project(bounds.getNorthWest());
        let se = crs.project(bounds.getSouthEast());
        let point = map.latLngToContainerPoint(latlng);

        if (!_.isEmpty(options)) {
            let params = {
                service: 'wms',
                version: '1.1.1',
                request: 'GetFeatureInfo',
                layers: options.layers,
                query_layers: options.layers,
                styles: '',
                feature_count: 50,
                info_format: 'application/json',
                srs: crs.code,
                width: size.x,
                height: size.y,
                x: Math.round(point.x),
                y: Math.round(point.y)
            };

            params.bbox = [nw.x, se.y, se.x, nw.y].join(',');

            if (options.cql_filter) {
                params.cql_filter = options.cql_filter;
            }

            return this.vm.$http.get(this.vm.getWmsService(), {params: params}).then((response) => {
                return response.body.features;
            });
        }
    }
}

export default OOPT;


// WEBPACK FOOTER //
// ./src/components/OOPT.js